import React from "react";
import SearchableSelect from "./SearchableSelect";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { setMember } from "../Slices/auth";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ReactLoading from "react-loading";
import axios from "axios";
import Toast from "./Toaster";
import toast from "react-hot-toast";
import { memberRegisterSchema } from "../schemas";
import { logoutUser } from "../Slices/auth";
import mode from "./Mode";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import PhoneUpdate from "./phoneUpdate";


const MemberRegister = () => {

  const [openPhoneModal, setOpenPhoneModal] = useState(false);



  //authorization
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const navigate = useNavigate();
  const baseurl = mode
    ? "https://backend.portal.jkusdachurch.org/general/"
    : "http://127.0.0.1:8000/general/";

  const config = React.useMemo(() => {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    return { headers };
  }, [token]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user == null) {
      toast.error("Unauthorized, login", {
        duration: 5000,
        position: "bottom-left",
      });
      navigate("/login", { state: { reason: "Unauthorized" } });
    }
    // Fetch courses from API
    //console.log(baseurl)
    axios
      .get(baseurl + "courses/", config)
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data)) {
          setCourses(
            response.data.map((course) => ({
              label: course.name,
              value: course.id,
            })),
          );
        }
        setCoursesLoading(false);
      })
      .catch((err) => {
        setCourses([]);
        setCoursesLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, baseurl, config, navigate]);

  const normalizePhone = (phone) =>
  phone.replace(/^(\+254|0)/, "").trim().slice(0, 9);


  const onSubmit = () => {
  setIsLoading(true);

  const phones = values.phone_numbers
    .map(p => p.trim())
    .filter(p => p !== "");

  // Primary phone required
  if (!phones[0]) {
    toast.error("Primary phone number is required");
    setIsLoading(false);
    return;
  }

  // Normalize phone numbers for a consistent payload
  const normalizedPhones = phones.map(normalizePhone);

const phonePayload = {
  phone_numbers: normalizedPhones,
  primary_phone: normalizedPhones[0],
};


  const selectedCourse = courses.find((c) => c.label === values.course);


  const payload = {
    first_name: values.first_name,
    last_name: values.last_name,
    ...phonePayload,
    course: selectedCourse?.label || "",
    baptised: Number(values.baptised),
    intake: Number(values.intake),
    gender: values.gender === "M" ? "Male" : "Female",
    reg_no: values.reg_no,
    next_of_kin: values.next_of_kin,
    home_church: values.home_church,
  };

  // For debugging: log the payload
  //console.log("Payload being sent to backend:", payload);


  axios
    .post(baseurl + "add-member/" + user.id + "/", payload, config)
    .then((response) => {
      dispatch(setMember(response.data));
      toast.success("Successful Registration");
      setTimeout(() => navigate("/dashboard"), 3000);
    })
    .catch((err) => {
      toast.error(err.response?.data?.Error || "An error occurred");
      if (err.response?.status === 401) {
        dispatch(logoutUser());
        navigate("/login");
      }
      setIsLoading(false);
    });
};
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      phone_numbers: [""],
      course: "",
      next_of_kin: "",
      home_church: "",
      baptised: "",
      intake: "",
      gender: "",
      reg_no: "",
    },
    validationSchema: memberRegisterSchema,
    onSubmit,
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  return (
    <>
      <Toast />
      <br />
      <br />
      <div className="container content-section">
        <div
          className="row d-flex flex-column align-items-center justify-content-center m-auto"
          style={{ backgroundColor: "transparent", border: "none" }}
        >
          <div
            className="content-section content col-md-9 m-auto"
            style={{ backgroundColor: "white" }}
          >
            {coursesLoading ? (
              <ReactLoading
                type="spin"
                color="rgb(11, 43, 66)"
                height={40}
                width={40}
              />
            ) : courses.length === 0 ? (
              <div className="alert alert-warning">
                No courses available. Registration is currently closed.
              </div>
            ) : (
              <form method="POST" className="forms" onSubmit={handleSubmit}>
                <fieldset>
                  <legend className="mb-4" style={{ color: "#228bdf" }}>
                    Member Details
                  </legend>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <br />
                      <TextField
                        label="First Name"
                        fullWidth
                        required
                        error={errors.first_name && touched.first_name}
                        id="outlined-size-small"
                        size="small"
                        name="first_name"
                        variant="standard"
                        value={values.first_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.first_name && touched.first_name && (
                        <p className="error">{errors.first_name}</p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <br />
                      <TextField
                        label="Last Name"
                        fullWidth
                        required
                        error={errors.last_name && touched.last_name}
                        id="outlined-size-small"
                        variant="standard"
                        size="small"
                        name="last_name"
                        value={values.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.last_name && touched.last_name && (
                        <p className="error">{errors.last_name}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-3">
                      <br />
                      {/* MultiPhoneInput Component for Phone Numbers */}
                      

<button
  type="button"
  className="btn btn-outline-primary w-100"
  onClick={() => setOpenPhoneModal(true)}
>
  Add phone numbers ({values.phone_numbers.filter(p => p.trim()).length})
</button>

{errors.phone_numbers && touched.phone_numbers && (
  <p className="error">{errors.phone_numbers}</p>
)}


                      {errors.phone_numbers && touched.phone_numbers && (
                        <p className="error">{errors.phone_numbers}</p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <br />
                      <FormControl
                        fullWidth
                        error={errors.gender && touched.gender}
                        required
                        variant="standard"
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Gender
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          name="gender"
                          value={values.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="M">MALE</MenuItem>
                          <MenuItem value="F">FEMALE</MenuItem>
                        </Select>
                      </FormControl>
                      {errors.gender && touched.gender && (
                        <p className="error">{errors.gender}</p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <br />
                      <FormControl
                        fullWidth
                        error={errors.intake && touched.intake}
                        required
                        variant="standard"
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Intake
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          name="intake"
                          value={values.intake}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>

                          {Array.from({ length: 10 }, (_, i) => {
                            const year = new Date().getFullYear() - i;
                            return (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            );
                          })}
                          <MenuItem value="0000">Associate</MenuItem>
                        </Select>
                      </FormControl>
                      {errors.intake && touched.intake && (
                        <p className="error">{errors.intake}</p>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <br />
                      <FormControl
                        fullWidth
                        error={errors.baptised && touched.baptised}
                        required
                        variant="standard"
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Baptised
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          name="baptised"
                          value={values.baptised}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="1">YES</MenuItem>
                          <MenuItem value="0">NO</MenuItem>
                        </Select>
                      </FormControl>
                      {errors.baptised && touched.baptised && (
                        <p className="error">{errors.baptised}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <br />
                      {/* Searchable Select for Course */}
                      <SearchableSelect
  label="Course"
  options={courses}
  value={values.course}   // <-- must be LABEL string
  name="course"
  onChange={(e) => setFieldValue("course", e.target.value)}
  onBlur={handleBlur}
  error={errors.course && touched.course}
  required
/>


                      {errors.course && touched.course && (
                        <p className="error">{errors.course}</p>
                      )}
                    </div>
                    
                    <div className="form-group col-md-6">
                      <br />
                      <TextField
                        label="School Reg Number"
                        fullWidth
                        error={errors.reg_no && touched.reg_no}
                        required
                        id="outlined-size-small"
                        variant="standard"
                        size="small"
                        name="reg_no"
                        value={values.reg_no}
                        onChange={(e) => {
                          const trimmedReg = e.target.value.trim();
                          handleChange({
                            target: {
                              name: "reg_no",
                              value: trimmedReg,
                            },
                          });
                        }}
                        onBlur={handleBlur}
                      />
                      {errors.reg_no && touched.reg_no && (
                        <p className="error">{errors.reg_no}</p>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <br />
                      <TextField
                        label="Next of Kin Phone No."
                        fullWidth
                        error={errors.next_of_kin && touched.next_of_kin}
                        required
                        id="outlined-size-small"
                        variant="standard"
                        size="small"
                        name="next_of_kin"
                        value={values.next_of_kin}
                        onChange={(e) => {
                          const trimmedkinPhone = e.target.value.trim(); //remove trailing white
                          handleChange({
                            target: {
                              name: "next_of_kin",
                              value: trimmedkinPhone,
                            },
                          });
                        }}
                        onBlur={handleBlur}
                      />
                      {errors.next_of_kin && touched.next_of_kin && (
                        <p className="error">{errors.next_of_kin}</p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <br />
                      <TextField
                        label="Home Church"
                        fullWidth
                        error={errors.home_church && touched.home_church}
                        required
                        id="outlined-size-small"
                        variant="standard"
                        size="small"
                        name="home_church"
                        value={values.home_church}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.home_church && touched.home_church && (
                        <p className="error">{errors.home_church}</p>
                      )}
                    </div>
                  </div>
                </fieldset>
                <div className="form-group pt-3">
                  <button
                    className="btn btn-outline-info"
                    type="submit"
                    disabled={isLoading}
                    style={{ borderRadius: "0.5rem" }}
                  >
                    {" "}
                    {isLoading ? (
                      <ReactLoading
                        type="spin"
                        color="rgb(11, 43, 66)"
                        height={25}
                        width={25}
                      />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
        <br />
      </div>

<PhoneUpdate
  page="member"
  open={openPhoneModal}
  onClose={() => setOpenPhoneModal(false)}
  values={values}
  setFieldValue={setFieldValue}
  onSave={() => setOpenPhoneModal(false)}
/>


    </>
    // ...existing code...
  );
};

export default MemberRegister;
